(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["car-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('car-gallery')) {
  class CarGallery extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.ac = new AbortController();
      this.on = { signal: this.ac.signal };
      this.passive = { passive: true, signal: this.ac.signal };
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.holds = {};
      this.initCountdown();

      this.track = this.querySelector('.cg__track');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.children);
      this.pills = Array.prototype.slice.call(this.querySelectorAll('.cg__thumb'));
      this.thumbsWrap = this.querySelector('.cg__thumbs');
      this.caption = this.querySelector('.cg__caption');
      this.counter = this.querySelector('.cg__counter-current');
      this.index = 0;

      this.pills.forEach(function (pill, i) {
        pill.addEventListener('click', function () { self.goTo(i); }, self.on);
      });
      var prev = this.querySelector('.cg__controls .cg__nav--prev');
      var next = this.querySelector('.cg__controls .cg__nav--next');
      if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); }, this.on);
      if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); }, this.on);

      this.track.addEventListener('scroll', function () { self.onScroll(); }, this.passive);
      window.addEventListener('resize', function () {
        cancelAnimationFrame(self.resizeFrame);
        self.resizeFrame = requestAnimationFrame(function () {
          self.track.scrollTo({ left: self.slides[self.index].offsetLeft });
        });
      }, this.passive);

      this.addEventListener('shopify:block:select', function (e) {
        var i = self.slides.findIndex(function (s) { return s.dataset.blockId === e.detail.blockId; });
        if (i < 0) return;
        self.hold('editor', true);
        self.goTo(i);
      }, this.on);
      this.addEventListener('shopify:block:deselect', function () { self.hold('editor', false); }, this.on);

      this.initLightbox();

      if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reduce) {
        this.classList.add('cg--playing');
        var pillsWrap = this.thumbsWrap;
        if (!pillsWrap) {
          var ms = parseFloat(this.dataset.speed) || 5000;
          this.autoTimer = setInterval(function () {
            if (!self.classList.contains('is-paused')) self.goTo(self.index + 1);
          }, ms);
        }
        if (pillsWrap) {
          pillsWrap.addEventListener('animationend', function (e) {
            if (e.target.parentNode === self.pills[self.index]) self.goTo(self.index + 1);
          }, this.on);
        }
        var slider = this.querySelector('.cg__slider');
        slider.addEventListener('mouseenter', function () { self.hold('hover', true); }, this.on);
        slider.addEventListener('mouseleave', function () { self.hold('hover', false); }, this.on);
        this.track.addEventListener('touchstart', function () { self.hold('touch', true); }, this.passive);
        this.track.addEventListener('touchend', function () {
          setTimeout(function () { self.hold('touch', false); }, 600);
        }, this.passive);
        document.addEventListener('visibilitychange', function () { self.hold('tab', document.hidden); }, this.on);
        if ('IntersectionObserver' in window) {
          this.viewObserver = new IntersectionObserver(function (entries) {
            self.hold('view', !entries[0].isIntersecting);
          }, { threshold: 0.25 });
          this.viewObserver.observe(this.track);
        }
      }
    }

    disconnectedCallback() {
      if (this.ac) this.ac.abort();
      if (this.viewObserver) this.viewObserver.disconnect();
      clearTimeout(this.settleTimer);
      clearInterval(this.countTimer);
      clearInterval(this.autoTimer);
      clearTimeout(this.captionTimer);
    }

    hold(key, value) {
      this.holds[key] = value;
      var paused = false;
      for (var k in this.holds) if (this.holds[k]) paused = true;
      this.classList.toggle('is-paused', paused);
    }

    setActive(i) {
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      if (i === this.index) return;
      this.index = i;
      this.render();
    }

    render() {
      var self = this;
      var i = this.index;
      this.pills.forEach(function (pill, n) {
        pill.classList.toggle('is-active', n === i);
        if (n === i) pill.setAttribute('aria-current', 'true');
        else pill.removeAttribute('aria-current');
      });
      if (this.counter) this.counter.textContent = i + 1;
      var active = this.pills[i];
      if (active && this.thumbsWrap) {
        var w = this.thumbsWrap;
        var left = active.offsetLeft - (w.clientWidth - active.offsetWidth) / 2;
        w.scrollTo({ left: Math.max(0, left) });
      }
      if (this.caption) {
        var text = this.slides[i].dataset.caption || '';
        this.caption.classList.add('is-swapping');
        clearTimeout(this.captionTimer);
        this.captionTimer = setTimeout(function () {
          self.caption.textContent = text;
          self.caption.classList.remove('is-swapping');
        }, this.reduce ? 0 : 200);
      }
      if (this.lb && this.lb.open) this.updateLightbox();
    }

    goTo(i) {
      var self = this;
      var n = (i + this.slides.length) % this.slides.length;
      this.programmatic = true;
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(function () { self.programmatic = false; }, 700);
      this.track.scrollTo({ left: this.slides[n].offsetLeft, behavior: this.reduce ? 'auto' : 'smooth' });
      this.setActive(n);
    }

    onScroll() {
      if (this.programmatic) return;
      var self = this;
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(function () {
        var w = self.track.clientWidth || 1;
        self.setActive(Math.round(self.track.scrollLeft / w));
      });
    }

    /* Draw countdown: data-end is the draw time in Unix seconds */
    initCountdown() {
      var box = this.querySelector('.cg__countdown[data-end]');
      if (!box) return;
      clearInterval(this.countTimer);
      var end = parseInt(box.dataset.end, 10) * 1000;
      if (!end || isNaN(end)) { box.hidden = true; return; }
      var self = this;
      var cta = this.querySelector('.cg__cta');
      var num = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { num[k] = box.querySelector('[data-unit="' + k + '"]'); });
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (num.d) num.d.textContent = Math.floor(left / 86400);
        if (num.h) num.h.textContent = pad(Math.floor(left % 86400 / 3600));
        if (num.m) num.m.textContent = pad(Math.floor(left % 3600 / 60));
        if (num.s) num.s.textContent = pad(left % 60);
        var ended = left === 0;
        self.classList.toggle('is-ended', ended);
        if (cta) {
          if (ended) { cta.setAttribute('aria-disabled', 'true'); cta.setAttribute('tabindex', '-1'); }
          else { cta.removeAttribute('aria-disabled'); cta.removeAttribute('tabindex'); }
        }
        if (ended) clearInterval(self.countTimer);
      }
      tick();
      this.countTimer = setInterval(tick, 1000);
    }

    /* Full-screen viewer: click a photo, or press Enter on the gallery */
    initLightbox() {
      var self = this;
      var dialog = this.querySelector('.cg__lightbox');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      this.lb = dialog;
      this.lbMedia = dialog.querySelector('.cg__lb-media');
      this.classList.add('cg--lightbox');
      function open() {
        self.updateLightbox();
        dialog.showModal();
        self.hold('lightbox', true);
      }
      this.track.addEventListener('click', open, this.on);
      this.track.addEventListener('keydown', function (e) { if (e.key === 'Enter') open(); }, this.on);
      dialog.addEventListener('close', function () { self.hold('lightbox', false); }, this.on);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); }, this.on);
      dialog.querySelector('.cg__lb-close').addEventListener('click', function () { dialog.close(); }, this.on);
      var p = dialog.querySelector('.cg__nav--prev');
      var n = dialog.querySelector('.cg__nav--next');
      if (p) p.addEventListener('click', function () { self.goTo(self.index - 1); }, this.on);
      if (n) n.addEventListener('click', function () { self.goTo(self.index + 1); }, this.on);
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') self.goTo(self.index - 1);
        if (e.key === 'ArrowRight') self.goTo(self.index + 1);
      }, this.on);
    }

    updateLightbox() {
      var slide = this.slides[this.index];
      var el;
      if (slide.dataset.full) {
        var src = slide.querySelector('img');
        el = document.createElement('img');
        el.src = slide.dataset.full;
        el.alt = src ? src.alt : '';
      } else {
        el = slide.firstElementChild.cloneNode(true);
      }
      this.lbMedia.innerHTML = '';
      this.lbMedia.appendChild(el);
    }
  }
  customElements.define('car-gallery', CarGallery);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('footer-menus')) {
    class FooterMenus extends HTMLElement {
      connectedCallback() {
        this.details = Array.prototype.slice.call(this.querySelectorAll('details'));
        this.mq = window.matchMedia('(min-width: 750px)');
        this.onChange = this.sync.bind(this);
        this.onClick = this.guard.bind(this);
        this.addEventListener('click', this.onClick);
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onChange);
        else this.mq.addListener(this.onChange);
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onChange);
        else this.mq.removeListener(this.onChange);
      }

      /* Phones: tap to open. Tablet/desktop: always open, headings are just labels. */
      sync() {
        var wide = this.mq.matches;
        this.details.forEach(function (d) {
          d.open = wide;
          var s = d.querySelector('summary');
          if (s) s.setAttribute('tabindex', wide ? '-1' : '0');
        });
      }

      guard(e) {
        if (this.mq.matches && e.target.closest('summary')) e.preventDefault();
      }
    }

    customElements.define('footer-menus', FooterMenus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
